<template>
  <div>
    <v-card outlined class="pa-4 pa-sm-8" max-width="650">
      <v-alert color="primary" text class="pl-8 mb-8">
        <ressource code="informations_inexactes_avertissement" />
      </v-alert>
      <v-row>
        <v-col cols="12" md="2">
          <v-icon x-large>mdi-account</v-icon>
        </v-col>
        <v-col cols="12" md="10">
          <CarteIdentificationLigne code="prenom" :value="identification.prenom" />
          <CarteIdentificationLigne code="nom" :value="identification.nomFamille" />
          <CarteIdentificationLigne code="courriel" :value="identification.courriel" />
          <CarteIdentificationLigne code="telephone" :value="identification.telephone" />
          <CarteIdentificationLigne
            v-if="showDateNaissance && identification.dateNaissance"
            code="date_naissance"
            :value="identification.dateNaissance"
          />
          <CarteIdentificationLigne v-if="showSexe && identification.sexe" code="sexe" :value="identification.sexe" />
        </v-col>
      </v-row>
      <v-divider class="my-6"></v-divider>
      <v-row>
        <v-col cols="12" md="2">
          <v-icon x-large>mdi-home</v-icon>
        </v-col>
        <v-col cols="12" md="10">
          <CarteIdentificationLigne code="adresse" :value="identification.adresse" />
          <CarteIdentificationLigne code="adresse_2" :value="identification.adresseLigne2" />
          <CarteIdentificationLigne code="code_postal" :value="identification.codePostal" />
          <CarteIdentificationLigne code="ville" :value="identification.ville" />
          <CarteIdentificationLigne code="pays" :value="identification.pays" />
          <CarteIdentificationLigne code="province" :value="identification.province" />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import CarteIdentificationLigne from "./CarteIdentificationLigne.vue"
import CataloguesHelpers from "../ui/mixins/CataloguesHelpers"
export default {
  mixins: [CataloguesHelpers],
  components: { CarteIdentificationLigne },
  props: {
    identification: Object,
    showDateNaissance: { type: Boolean, default: false },
    showSexe: { type: Boolean, default: false }
  }
}
</script>

<style>
</style>